import axios from 'axios';
import { GET_DOAS, GET_SPECIFIC_DOA, ASK_DOA, ANSWER_DOA, UPDATE_BIEN_DOA, DELETE_DOA, CLEAR_DOAS, DOAS_LOADING } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { IDoa } from '../../types/interfaces';

export const getDoas = () => (dispatch: Function, getState: Function) => {
  // dispatch(setDoasLoading());
  dispatch({
    type: DOAS_LOADING
  });
  axios
    .get('/api/doas', tokenConfig(getState))
    .then(res =>
      dispatch({
        type: GET_DOAS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getDoaById = (id: number) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: DOAS_LOADING
  });
  axios
    .get('/api/doas/specific', {...tokenConfig(getState), params: {id}})
    .then(res =>
      dispatch({
        type: GET_SPECIFIC_DOA,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const askDoa = (bien_id: number, superficie: number, old_price: number, new_price: number, assVenteIdImage: number, association: any, comment: string, user_id: number | undefined, username: string | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/doas/ask', {bien_id, superficie, old_price, new_price, assVenteIdImage, association, comment, user_id, username}, tokenConfig(getState))
    .then(res =>{
      dispatch({
        type: ASK_DOA,
        payload: res.data
      });
      dispatch({
        type: UPDATE_BIEN_DOA,
        payload: [res.data]
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const answerDoa = (id: number, bien_id: number, approved: number, new_priceM: number, new_priceT: number, association: any, saveSample: number, sampleName: string, by_user_id: number | undefined, by_username: string | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/doas/answer', {id, bien_id, approved, new_priceM, new_priceT, association, saveSample, sampleName, by_user_id, by_username}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: ANSWER_DOA,
        payload: res.data
      });
      dispatch({
        type: UPDATE_BIEN_DOA,
        payload: [res.data]
      });
      callback(res.data, approved)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const deleteDoa = (id: number, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .delete(`/api/doas/${id}`, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: DELETE_DOA,
        payload: id
      })
      callback(true)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const clearDoas = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_DOAS
  })
};